import Auth from './auth';

function getView(path) {
  return () => import(/* webpackChunkName: "views/[request]" */ `Components/${path}`);
}

/**
 * Returns true if production environment
 *
 * @returns {boolean}
 */
function isProd() {
  return process.env.NODE_ENV === 'production';
}

/**
 * Returns true if dev environment
 *
 * @returns {boolean}
 */
function isDev() {
  return process.env.NODE_ENV === 'development';
}

/**
 * Returns true if test environment
 *
 * @returns {boolean}
 */
function isTest() {
  return process.env.NODE_ENV === 'testing';
}

/**
 * Returns an environment variable
 *
 * @param key {string} A key to be retrieved by
 * @returns {*}
 */
function getEnv(key) {
  return process.env[`VUE_APP_${key.toUpperCase()}`];
}

/**
 * Capitalizes first letters of each word after space
 *
 * @deprecated Use `ucwords` instead
 * @param string {string} A string to be processed
 * @returns {*}
 * @example
 * capitaliseFirstLetterAfterSpace('This is a test') // This Is A Test
 * capitaliseFirstLetterAfterSpace('This IS a TEST') // This IS A TEST
 */
function capitaliseFirstLetterAfterSpace(string) {
  return string.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}

/* Auth */

/**
 * Redirects non-authenticated users to the home page
 *
 * @param to {object} Vue-router `to` object
 * @param from {object} Vue-router `from` object
 * @param next {function} Vue-router `next` function
 */
function requireAuth(to, from, next) {
  Auth.refreshSession().then(async (result) => {
    if (!result) {
      return Promise.resolve('login');
    }

    return Promise.resolve();
  }).then((name) => {
    Auth.loadLoginUser().then(async (u) => {
      if (!!u && u.role === 'View Only') {
        console.log(to.name);
        if (to.name.includes('Edit') || to.name.includes('create') || to.name.includes('Delete') || to.name === ('dosing')) {
          next({ name: 'contactForm' });
        } else {
          next({ name });
        }
      } else if (!!u && u.role === 'Operator') {
        console.log(to.name);
        if (to.name.includes('Edit') || to.name.includes('create') || to.name.includes('Delete')) {
          next({ name: 'contactForm' });
        } else {
          next({ name });
        }
      } else {
        next({ name });
      }
    });
  })
    .catch((e) => {
      const path = to ? ` to ${to.path}` : '';
      const message = e ? ` Reason: ${e.message}` : '';
      console.warn(`Error navigating${path}.${message}`);
      next({ name: 'systemError' });
    });
}

/**
 * Redirects authenticated users to the home page
 *
 * @param to {object} Vue-router `to` object
 * @param from {object} Vue-router `from` object
 * @param next {function} Vue-router `next` function
 */
function rejectAuth(to, from, next) {
  Auth.refreshSession().then(async (result) => {
    if (!result) {
      return Promise.reject();
    }
    const loginUser = await Auth.loadLoginUser();
    return next({ name: loginUser.defaultRoute || 'assets' });
  }).catch(() => {
    next();
  });
}

/**
 * Redirects the user to 404 page with an optional message
 *
 * @param message {string} A message to show on the 404 page
 * @param skip {boolean} Whether to skip the redirection
 */
function show404(message = '', skip = true) {
  if (!skip) {
    return;
  }
  Auth.vue.$router.push({
    name: '404',
    query: {
      message: btoa(message),
    },
  });
}

export {
  capitaliseFirstLetterAfterSpace,
  requireAuth,
  rejectAuth,
  show404,
  isDev,
  isTest,
  isProd,
  getEnv,
  getView,
};
